<app-settings-base
  title="{{'cronJobSettings.title' | translate}}"
  description="{{'cronJobSettings.text' | translate}}"
  details="{{'cronJobSettings.detailsHeader' | translate}}"
  sourceUrl="/setting/cron-job">
</app-settings-base>
